import { useEffect, useState } from "react";
import axios from "axios";
import { Cpu } from "lucide-react";
import { API, useAuth } from "../../App";

const STORAGE_KEY = "unq_ai_text_model";

export const useAiModel = () => {
  const [model, setModel] = useState(() => localStorage.getItem(STORAGE_KEY) || "openai");
  const pick = (m) => { localStorage.setItem(STORAGE_KEY, m); setModel(m); };
  return [model, pick];
};

export const AiModelSelect = ({ value, onChange, className = "" }) => {
  const { token } = useAuth();
  const [models, setModels] = useState([]);

  useEffect(() => {
    axios.get(`${API}/ai/models`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setModels(r.data.models || []))
      .catch(() => setModels([]));
  }, [token]);

  if (!models.length) return null;
  return (
    <label className={`inline-flex items-center gap-1.5 text-xs text-slate-500 ${className}`} data-testid="ai-model-select-wrap">
      <Cpu className="w-3.5 h-3.5 text-[#0A2342]" />
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="bg-white border border-slate-200 rounded-md px-2 py-1 text-xs text-[#0A2342] focus:outline-none focus:ring-2 focus:ring-[#C8A96B]/40"
        data-testid="ai-model-select"
      >
        {models.map((m) => (
          <option key={m.key} value={m.key}>{m.label}</option>
        ))}
      </select>
    </label>
  );
};
